/**
 * HTML elements that can be used as a block wrapper.
 */
var ELEMENTS = ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ol', 'ul', 'li', 'figure', 'nav', 'pre', 'header', 'section', 'aside', 'footer', 'main'];
export default ELEMENTS;
//# sourceMappingURL=block-wrapper-elements.js.map